export const PREFIX = "@commonActions/";

export const LOADING_CSV_REPORT = `${PREFIX}LOADING_CSV_REPORT`;
export const SUCCESS_CSV_REPORT = `${PREFIX}SUCCESS_CSV_REPORT`;
export const ERROR_CSV_REPORT = `${PREFIX}ERROR_CSV_REPORT`;
export const RESET_CSV_REPORT = `${PREFIX}RESET_CSV_REPORT`;

export const VALIDATION_ERRORS = `${PREFIX}VALIDATION_ERRORS`;

export const RESET_VALIDATION_ERRORS = `${PREFIX}RESET_VALIDATION_ERRORS`;